/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useAuth from "../Hooks/useAuth";
import {
  usePopularListingOfRelatedListing,
  useRelatedListingOfRelatedListing,
} from "../Hooks/useListing";
import {
  useAddRecentViwed,
  useServicesById,
} from "../Hooks/useServices";
import ServiceDetailsContainer from "../sections/ServiceDetails/ServiceDetailsContainer";
import ServiceDetailsSkeleton from "../components/common/Skeletons/ServiceDetailsSkeleton";
import { GetPostById, IncrementPostViews } from "../services/PostService";
import { useGraphQL } from "../context/GraphQLProvider";
import { publicMainHeaderOffsetClass } from "../sections/Public/shared/publicLayoutSpec";

const ServiceDetail = () => {
  function useParams() {
    return new URLSearchParams(useLocation().search);
  }
  const params = useParams();
  const ListingId = params.get("id");
  const { auth } = useAuth();
  const graphqlService = useGraphQL();
  const [postData, setPostData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const { status: AuthnicateStatus, data: AuthnicateData } = useServicesById(
    auth?.user?.id
  );
  useAddRecentViwed(auth?.user?.id, ListingId);

  // const { status: isLoadingPopularServices, data: PopularServices } =
  //   usePopularListingOfRelatedListing(ListingId, auth?.user?.id ?? null);
  // const { status: isLoadingRelatedServices, data: RelatedServices } =
  //   useRelatedListingOfSelectedListing(ListingId, auth?.user?.id ?? null);

  useEffect(() => {
    const fetchPostDetails = async () => {
      if (ListingId) {
        setIsLoading(true);
        try {
          const response = await GetPostById(graphqlService, { id: parseFloat(ListingId) });
          const postDetails = response?.getPostById;
          setPostData(postDetails);
          
          // Update views only after increment response
          const incrementResponse = await IncrementPostViews(graphqlService, { id: parseFloat(ListingId) });
          if (incrementResponse?.incrementPostViews) {
            setPostData(prev => ({
              ...prev,
              views: incrementResponse.incrementPostViews.views
            }));
          }
        } catch (err) {
          console.error("Error fetching post details:", err);
          setError(err);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchPostDetails();
  }, [ListingId, graphqlService]);

  // useEffect(() => {
  //   const prevBg = document.body.style.background;
  //   document.body.style.background = '#fff';
  //   return () => {
  //     document.body.style.background = prevBg;
  //   };
  // }, []);

  if (error) {
    return (
      <div className={`${publicMainHeaderOffsetClass()} text-center`}>
        Error loading post details
      </div>
    );
  }

  return (
    <>
      {isLoading ? (
        <ServiceDetailsSkeleton />
      ) : (
        postData && (
          <ServiceDetailsContainer
            data={postData}
            // ListingId={ListingId}
            // AuthnicateData={AuthnicateData}
            // listRating={postData.likes || 0}
          />
        )
      )}
    </>
  );
};

export default ServiceDetail;
